const escapeCsv = (value) => {
  const text = value == null ? '' : String(value);
  return `"${text.replace(/"/g, '""')}"`;
};

/**
 * Download rows as a CSV file.
 * columns: [key | (row, index) => value, label][]
 */
export const downloadCsv = (filename, rows, columns) => {
  const csv = [
    columns.map(([, label]) => escapeCsv(label)).join(','),
    ...rows.map((row, index) => columns
      .map(([key]) => escapeCsv(typeof key === 'function' ? key(row, index) : row[key]))
      .join(',')),
  ].join('\n');
  // BOM so Excel opens non-ASCII characters as UTF-8.
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

/** Save a Blob (e.g. a CSV returned by the API) as a file. */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
